'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var SET = 'set';
var DIMENSION = 'dimension7';
var VALUE = 'MERCADOSHOPS';
var MeliGaTrackerService = /*#__PURE__*/function () {
  function MeliGaTrackerService() {
    _classCallCheck__default["default"](this, MeliGaTrackerService);
  }
  return _createClass__default["default"](MeliGaTrackerService, null, [{
    key: "isMeliGaEnabled",
    value: function isMeliGaEnabled() {
      return typeof meli_ga === 'function';
    }
  }, {
    key: "sendEventTrack",
    value: function sendEventTrack() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isMeliGaEnabled() || !track.eventCategory || !track.eventAction) {
        return;
      }
      meli_ga(SET, DIMENSION, VALUE);
      var customDimensions = track.customDimensions;
      var dimensionsKeys = customDimensions ? Object.keys(customDimensions) : [];
      dimensionsKeys.forEach(function (key) {
        meli_ga('set', "dimension".concat(key), customDimensions["".concat(key)]);
      });
      meli_ga('send', _objectSpread__default["default"](_objectSpread__default["default"]({}, track), {}, {
        hitType: 'event'
      }));
    }
  }, {
    key: "sendViewTrack",
    value: function sendViewTrack() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isMeliGaEnabled() || !track.path) {
        return;
      }
      meli_ga(SET, DIMENSION, VALUE);
      var customDimensions = track.customDimensions;
      var dimensionsKeys = customDimensions ? Object.keys(customDimensions) : [];
      dimensionsKeys.forEach(function (key) {
        meli_ga('set', "dimension".concat(key), customDimensions["".concat(key)]);
      });
      meli_ga('send', 'pageview', track.path);
    }
  }]);
}();
exports.MeliGaTrackerService = MeliGaTrackerService;
exports["default"] = MeliGaTrackerService;
